module.exports = __webpack_public_path__ + "img/icon-motivation.405d10a1.svg";